import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { MenuItem, MessageService } from 'primeng/api';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { crop_Datas } from '../../../models/farmer-land.model';
import { FarmerLandDetailService } from 'src/app/services/farmer-land-detail.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import exifr from 'exifr';
import piexifjs from 'piexifjs';
import saveAs from 'file-saver';

@Component({
  selector: 'app-pre-estimate-survey',
  templateUrl: './pre-estimate-survey.component.html',
  styleUrls: ['./pre-estimate-survey.component.scss'],
})
export class PreEstimateSurveyComponent implements OnInit {
  @ViewChild('farmerPreEstimateSurveyTable', { static: true })
  public farmerPreEstimateSurveyTable: Table;
  @ViewChild('geolocationsarrayTable', { static: true })
  public geolocationsarrayTable: Table;
  public farmerPreEstimateSurveyData: any = [];
  mobileFarmerPreEstimateSurveyData: any = [];
  displayPreEstDialog: boolean = false;
  isSubmitted: boolean = false;
  submitEstimateForm: FormGroup;
  latitude: any;
  longitude: any;
  geolocationsarray: any = [];
  overlays: any = [];
  mapEnable = false;
  public vendorRegId: any;
  selectedWatersourceType: string;
  componentList: any = [];
  public userId: any;
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  options = {
    center: { lat: 29.0588, lng: 76.0856 },
    zoom: 17,
    mapTypeId: google.maps.MapTypeId.SATELLITE,
    // draggable: false,
    // icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
  };

  programmeAppId: any;
  programmeFarmerName: any;
  programName: any;
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public webcamImage!: WebcamImage;
  public videoOptions: MediaTrackConstraints = {};
  public imageCaptured = false;
  public errors: WebcamInitError[] = [];
  private trigger: Subject<void> = new Subject<void>();
  @Output()
  public pictureTaken = new EventEmitter<WebcamImage>();
  displayBasic: boolean = false;
  displayCameraComponent: any = false;
  selctedFileType: any;
  documentList: any = [];
  insertPondAttachments: any = [];
  selectedCropType: any;
  selectedCorpModel: crop_Datas;
  selectedCorpModelList: any;
  selectedNodes1: any[] = [];
  cropTypeList: any[];
  allSchemeMaster: any[] = [];
  waterSourceList: any[];
  private nextWebcam: Subject<boolean | string> = new Subject<
    boolean | string
  >();
  waterSourceNames: any;
  ProgramID: any;
  cropBasedNames: any;
  error: string;
  vendorCode: any;
  allAttachementsList: any = [];
  attachementDisplayName: any = [];
  imageError: string;
  uploadOptions: any[];
  autoId: any;
  appId: any;
  editBilledData: boolean = false;
  coordinateError: any;
  public multiSortMeta: any;
  ipAddress: any = '000.000.000';
  landArea: number = 0;
  surveyArea: number = null;

  public refreshLocation: any;
  appVerificationItems:MenuItem[];
  appVerificationModel:any[]

  public isGPSError: boolean = false;
  public loading: boolean = false;
  constructor(
    private loader: AppLoaderService,
    private vendorService: VendorDashboardService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private flService: FarmerLandDetailService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private cryptoJsService: CryptoJsService,
    private farmerAppSer: FarmersApplicationService,
    private ipService: IpAddressService,
    public cd: ChangeDetectorRef,
    public router: Router
  ) {
    (this.waterSourceList = [
      { id: 1, waterSource: 'Canal' },
      { id: 2, waterSource: 'Tubewell' },
      { id: 3, waterSource: 'STP' },
      { id: 4, waterSource: 'Over Flow Pond' },
    ]),
      (this.uploadOptions = [
        { name: 'Farmer Photo', code: 'farmer_photo' },
        { name: 'Water Source', code: 'water_source' },
        { name: 'Land Photo', code: 'land_photo' },
        { name: 'Others', code: 'others' },
      ]);
  }

  ngOnInit(): void {
    // this.onCapture();
    // this.getCurrentLocation();
    // this.addOverlay();
    this.loadData();
    this.getCorpType();
    this.getIP();
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'Pre_estimate_survey_file');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.appVerificationModel,
            'Pre_estimate_survey_file'
          );
        },
      },
    ];
    // setTimeout(() => {
    //   console.log(this.overlays, 'geeee')
    //   if(this.overlays.length >=3){
    //     this.onDelect(0)
    //   }
    //   // else {
    //   //   this.overlays.forEach((val, index) => {
    //   //     if(val?.title == 'Coordinate 1'){
    //   //       this.overlays.splice(index, 1);
    //   //       this.geolocationsarray = [];
    //   //       this.onSave();
    //   //     }
    //   //   })
    //   // }
    // }, 5000)
    this.submitEstimateForm = this.fb.group({
      soilType: ['', Validators.required],
      cropType: ['', Validators.required],
      cropId: ['', Validators.required],
      waterSource: ['', Validators.required],
      waterPressure: ['', Validators.required],
      waterQuality: ['', Validators.required],
      ph: ['', Validators.required],
      ec: ['', Validators.required],
      waterReq: ['', Validators.required],
      plantSpacing: ['', Validators.required],
      rowSpacing: ['', Validators.required],
    });
    this.farmerPreEstimateSurveyTable.filters['Status_Ar'] = [
      { value: 'P', matchMode: 'equals', operator: 'and' },
    ];
    this.multiSortMeta = [];
    this.multiSortMeta.push({ field: 'AssignedDate', order: 1 });
    WebcamUtil.getAvailableVideoInputs().then(
      (mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      }
    );
  }

  onRefreshCurrentLocation(){
    // console.log("refreshLocation")
    this.overlays.forEach((val, index) => {
      if(val?.title == "Current Location"){
        this.overlays.splice(index, 1); 
      }
    })
    this.getCurrentLocation();
  }

  getCurrentLocation() {
    // console.log(this.overlays)
    let overlay = this.overlays;
    let mapEnable = this.mapEnable;
    let instant = this;
    this.coordinateError = '';
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      function success(pos) {
        const crd = pos.coords;
        const obj = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        instant.options.center = obj;
        // const image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';
        
          const currentLocationMarker = new google.maps.Marker({
          position: { lat: obj?.lat, lng: obj?.lng },
          title: 'Current Location',
          icon: '../../../assets/map/location-icon-5.png',
        });

        overlay.push(currentLocationMarker)
        // console.log(overlay);
        
        
        // instant.geolocationsarray.push(obj)
        // instant.onSave()
        // instant.addOverlay()
        instant.mapEnable = true;
      }

      function error(err) {
        instant.isGPSError = true;
        let detailsMsg = '';
        if(err?.message== 'User denied Geolocation'){
          detailsMsg = 'Please enable Geolocation access.'
        } else{
          detailsMsg = 'Please Refresh the Current Location.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg,
        });
        // console.log(`ERROR1(${err.code}): ${err.message}`);
      }

      // this.mapEnable = true;
      navigator.geolocation.getCurrentPosition(success, error, options);
      // this.addOverlay();
    }
  }

  get f() {
    return this.submitEstimateForm.controls;
  }
  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
      // console.log('ipAddresss', this.ipAddress);
    });
  }
  loadData() {
    const token: any = JSON.parse(sessionStorage.getItem('token'));
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    // const token: any = this.tokenService.retrieve();
    this.vendorRegId = JSON.stringify(token?.officeCode);
    // let payload = atob(token?.value?.authToken?.split('.')[1]);
   // this.loader.start();
   this.loading = true;
    this.vendorService
      .GetPreEstimationSurvey(JSON.parse(payload)?.sub)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(
            this.userId,
            'Pre-Estimation Survey',
            '',
            new Date(),
            'Success'
          );
          data.forEach((e) => {
            if (e.AssignedDate) {
              e.AssignedDate = new Date(e.AssignedDate);
              e.registerationDate_filter = e.AssignedDate.toString().substring(
                4,
                24
              );
            }
            if (e.LastSubmittedDate) {
              e.LastSubmittedDate = new Date(e.LastSubmittedDate);
              e.registerationReassignDate_filter =
                e.LastSubmittedDate.toString().substring(4, 24);
            }
          });
          // console.log(data, 'data');
          this.userId = JSON.parse(payload)?.sub;
          if (data.length > 0) {
            this.farmerPreEstimateSurveyData = data;
            this.appVerificationModel= this.farmerPreEstimateSurveyData 
            this.mobileFarmerPreEstimateSurveyData = data;
          }
          else{
            this.farmerPreEstimateSurveyData = [];
            this.appVerificationModel= [] 
            this.mobileFarmerPreEstimateSurveyData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(
            this.userId,
            'Pre-Estimation Survey',
            '',
            new Date(),
            err
          );
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
  getCorpType() {
    this.flService
      .GetCorpType()
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.cropTypeList = files;
          // console.log(this.cropTypeList, 'this.cropTypeList');
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Corp Type Details not loaded.',
          });
        },
      });
  }
  getCropTypeName(event) {
    const data = this.cropTypeList.find((element) => element.data == event);
    if (data) {
      this.cropBasedNames = data.children;
    } else {
      this.cropBasedNames = [];
    }
  }
  selectPreSurveyData(event) {}
  onCloseDialog() {
    this.isGPSError = false;
    clearInterval(this.refreshLocation);
    this.displayPreEstDialog = false;
    this.mapEnable = false;
    this.geolocationsarray = [];
    this.overlays = this.overlays.filter(val => {
      return !val?.title?.includes('Coordinate')
    });
    this.documentList = [];
    this.isSubmitted = false;
    this.submitEstimateForm.reset();
    this.landArea = 0;
    this.surveyArea = null;
    this.addOverlay();
  }
  onCapture() {
    let instant = this;
    this.coordinateError = '';
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      function success(pos) {
        let isInvalid = instant.geolocationsarray.find((data) => {
          if (
            data.lat == pos.coords.latitude &&
            data.lng == pos.coords.longitude
          ) {
            return data;
          }
        });

        if (isInvalid) {
          instant.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:
              'Please move to a different location to get new coordinates.',
          });
          return;
        }

        const crd = pos.coords;
        const obj = {
          CornerID: instant.geolocationsarray.length + 1,
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        instant.geolocationsarray.push(obj);
        instant.onSave();
      }

      function error(err) {
        let detailsMsg = '';
        if(err?.message== 'User denied Geolocation'){
          detailsMsg = 'Please enable Geolocation access'
        } else{
          detailsMsg = 'Please capture again.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg
            ,
        });
        // console.log(`ERROR(${err.code}): ${err.message}`);
      }

      navigator.geolocation.getCurrentPosition(success, error, options);
    }
  }

  onDelect(i) {
    // console.log(this.geolocationsarray)
    this.geolocationsarray.splice(i, 1);
    for (let index = 0; index < this.geolocationsarray.length; index++) {
      this.geolocationsarray[index].CornerID = index + 1;
    }
    // if (this.geolocationsarray.length == 0) {
    //   // this.mapEnable = false;
    //   this.mapEnable = true;
    // } else {
      this.options.center = this.geolocationsarray[0];
      this.mapEnable = false;
      this.mapEnable = true;
      this.overlays = [];
      this.geolocationsarray.forEach((row, index) => {
        this.addMarkers(row, index);
      });
      this.addOverlay();
    // }
  }

  onSave() {
    this.mapEnable = false;
    this.mapEnable = true;
    this.options.center = this.geolocationsarray[0];
    this.overlays = [];
    this.geolocationsarray.forEach((row, index) => {
      this.addMarkers(row, index);
    });
    this.addOverlay();
  }

  onNext() {}
  mobileSearch(value) {
    this.mobileFarmerPreEstimateSurveyData =
      this.farmerPreEstimateSurveyData.filter((data: any) => {
        if (
          data.appID.toLowerCase().includes(value.toLowerCase()) ||
          data.FarmerName.toLowerCase().includes(value.toLowerCase()) ||
          data.ProgrammeName.toLowerCase().includes(value.toLowerCase()) ||
          data.district.toLowerCase().includes(value.toLowerCase()) ||
          data.village.toLowerCase().includes(value.toLowerCase()) ||
          data.block.toLowerCase().includes(value.toLowerCase()) ||
          data.Status_Ar.toLowerCase().includes(value.toLowerCase())
        ) {
          return data;
        }
      });
  }
  addOverlay() {
    this.overlays.forEach((val, index) => {
      if(val?.fillColor){
        this.overlays.splice(index, 1);
      }
    })

    this.overlays.push(
      new google.maps.Polygon({
        paths: this.geolocationsarray,
        strokeOpacity: 0.5,
        strokeWeight: 1,
        fillColor: '#1976D2',
        fillOpacity: 0.35,
      })
    );
    // console.log(this.overlays);
    if(this.geolocationsarray.length >=3){
      let polygon = new google.maps.Polygon({paths: this.geolocationsarray})
      let area = this.calculateLandArea(polygon.getPath());
      this.landArea = Number((0.000247105*area).toFixed(2));
      // console.log("Calculated Area",this.landArea);
    }
    // this.onRefreshCurrentLocation();
  }

  calculateLandArea(polygon){
    return google.maps.geometry.spherical.computeArea(polygon)
  }

  removeOverlay() {
    this.overlays.pop().setMap(null);
  }
  addMarkers(row: any, index) {  
    this.overlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: 'Coordinate ' + row?.CornerID,
        draggable: false,
        crossOnDrag: false
      })
    );
  }

  onDrag(event) {
    // console.log("event", event, event?.overlay?.position?.lat(), event?.overlay?.position?.lng());
    // console.log(this.overlays);

    let index = -1;
    index = event?.overlay?.title ? event?.overlay?.title.split(' ')[1] : -1;
    if (index >= 1) {
      // console.log(this.geolocationsarray, index, this.geolocationsarray[index-1], this.geolocationsarray[index-1]['lat']);
      this.geolocationsarray[index - 1].lat = event?.overlay?.position?.lat();
      this.geolocationsarray[index - 1].lng = event?.overlay?.position?.lng();

      this.removeOverlay();
      this.addOverlay();
    }
  }

  showBasicDialog() {
    this.displayBasic = true;
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.imageCaptured = true;
    this.pictureTaken.emit(webcamImage);
  }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public uploadPicture() {
    const arr = this.webcamImage.imageAsDataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    exifr
      .parse(this.webcamImage.imageAsDataUrl)
      .then((output) => {//console.log('Camera:', output)
      } );
    // console.log(piexifjs.load(this.webcamImage.imageAsDataUrl));
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], this.selctedFileType + '.jpeg', {
      type: mime,
    });
    let data = new FormData();
    data.append('file', file);
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let phNo = JSON.parse(payload)?.sub;
    // this.route.queryParams
    //   .subscribe(params => {
    // if (params.autoId) {
    this._personalDetalSer
      .uploadFile(data, phNo, this.selctedFileType.code)
      .subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          const fileName = `preEstimateSurvey_${new Date().getTime()}`;
          this.documentList.push({
            attachment: resp.data,
            attachmentRawUrl: this.webcamImage.imageAsDataUrl,
            document_type: this.selctedFileType.name,
            displayName: fileName,
            name: this.selctedFileType.name,
            // this.selctedFileType.code === 'farmer_photo'
            //   ? 'Farmer Photo'
            //   : this.selctedFileType.code === 'water_source'
            //     ? 'Water Source'
            //     : this.selctedFileType.code === 'land_photo'
            //       ? 'Land Photo'
            //       : this.selctedFileType.code === 'others'
            //         ? 'Others'
            //         : 'Component Photo',
            isUploaded: false,
          });

          // let documentListObject = {
          //   // 'appId': this.cryptoJsService.DecryptData(params.appId),
          //   'documentList': this.documentList
          // }
          // sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
          this.selctedFileType = '';
          this.retake();
          this.displayCameraComponent = false;
        } else {
          // console.log('Error');
        }
        this.selctedFileType = '';
      });
    // });
  }
  retake() {
    this.imageCaptured = false;
  }
  onCaptureImage() {
    this.displayCameraComponent = true;
  }
  onCloseImageDialog() {
    this.displayCameraComponent = false;
    this.imageCaptured = false;
  }
  getImagesArray() {
    if (this.documentList.length == 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'ERROR_MESSAGE',
        detail: 'Images are Mandatory',
      });
      return;
    } else {
      this.uploadOptions.forEach((option) => {
        if (option.code != 'others') {
          let filtered = this.documentList.filter((doc) => {
            return doc.document_type == option.name;
          });
          if (filtered?.length == 0) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Atleast one ' + option.name + ' is Needed!',
            });
            return;
          }
        }
      });
    }
  }
  submitSurveyDetails() {
    let existImage = true;
    this.isSubmitted = true;
    if (this.submitEstimateForm.valid) {
      if (this.geolocationsarray.length < 4) {
        this.coordinateError = 'PLEASE_PROVIDE_ATLEAST_4_GPS_COORDINATES';
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Please provide atleast 4 GPS Coordinates',
        });
        return;
      } else if(this.landArea - this.surveyArea >= 1){
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: `Calculated Area (${this.landArea}) is much greater than Survey Area (${this.surveyArea}). Please recapture the coordinates.`,
        });
        return;
      } else if (this.documentList.length == 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Images are Mandatory',
        });
        return;
      } else {
        this.uploadOptions.forEach((option) => {
          if (option.code != 'others') {
            let filtered = this.documentList.filter((doc) => {
              return doc.document_type == option.name;
            });
            if (filtered?.length == 0) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Atleast one ' + option.name + ' is Needed!',
              });
              existImage = false;
            }
          }
        });
        let attachemntArray = [];
        if (!existImage) {
          return;
        }
        for (let index = 0; index < this.documentList.length; index++) {
          const obj = {
            attachmentsDoc: this.documentList[index].attachment,
            documentType: this.documentList[index].document_type,
          };
          attachemntArray.push(obj);
        }
        let geoCoordinates = [];
        for (let index = 0; index < this.geolocationsarray.length; index++) {
          const gpsObj = {
            CornerID: index + 1,
            latitude: this.geolocationsarray[index].lat,
            longitude: this.geolocationsarray[index].lng,
          };
          geoCoordinates.push(gpsObj);
        }
        const dataObj = [
          {
            appID: this.programmeAppId,
            progID: this.ProgramID,
            FarmerName: this.programmeFarmerName,
            soilType: this.submitEstimateForm.value.soilType,
            cropTypeID: this.submitEstimateForm.value.cropType,
            cropID: this.submitEstimateForm.value.cropId,
            waterSourceId: this.submitEstimateForm.value.waterSource,
            waterPressure: this.submitEstimateForm.value.waterPressure,
            waterQuality: this.submitEstimateForm.value.waterQuality,
            PH: this.submitEstimateForm.value.ph,
            EC: this.submitEstimateForm.value.ec,
            waterQuantity: this.submitEstimateForm.value.waterReq,
            plantSpacing: this.submitEstimateForm.value.plantSpacing,
            rowSpacing: this.submitEstimateForm.value.rowSpacing,
            vendorCode: this.vendorCode,
            network_Id: this.ipAddress,
            terminal_Id: this.ipAddress,
            insertServeyAttachments: attachemntArray,
            insertSurveyGPSCoordiantes: geoCoordinates,
          },
        ];
        
        this.flService
          .getPreEstimateSurvey(dataObj)
          .pipe(first())
          .subscribe({
            next: (resp) => {
              // this.loader.close();
          this.loading = false;
              this.activityRecordService.activityRecord(
                this.userId,
                'Pre-Estimation Survey Action',
                this.programmeAppId,
                new Date(),
                resp,
                dataObj[0]
              );
              this.messageService.add({
                severity: 'success',
                summary: 'Success Message',
                detail: resp,
              });
              this.isSubmitted = true;
              this.onCloseDialog();
              this.loadData();
            },
            error: (err) => {
              this.activityRecordService.activityRecord(
                this.userId,
                'Pre-Estimation Survey Action',
                this.programmeAppId,
                new Date(),
                err,
                dataObj[0]
              );
              this.isSubmitted = true;
              // this.loader.close();
               this.loading = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: err,
              });
            },
          });
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please fill all the mandatory feilds',
      });
    }
  }
  removeImg(i) {
    this.documentList.splice(i, 1);
  }
  rowBackgroundColor(row) {
    if (row.Status_Ar == 'P') {
      if (row.Pending_CompletedDays <= -2) {
        return '#ff8080';
      } else if (row.Pending_CompletedDays == -1) {
        return '#ffc966';
      }
    } else if (row.Status_Ar == 'C' || row.Status_Ar == 'A') {
      if (row.Pending_CompletedDays >= -1) {
        return '#99e699';
      } else if (row.Pending_CompletedDays <= -2) {
        return '#ffb3b3';
      }
    } else return '#ffffff';
  }
  addEstimation(data) {
    this.getCurrentLocation();
    this.addOverlay();
    this.refreshLocation = setInterval(() =>
        this.onRefreshCurrentLocation(), 6000)

    // setTimeout(() => {
    //   if(!this.isGPSError){
    //     this.refreshLocation = setInterval(() =>
    //     this.onRefreshCurrentLocation(), 5000)
    //   }
    // }, 7000)

    

    this.displayPreEstDialog = true;
    this.geolocationsarray = [];
    this.programmeAppId = data.appID;
    this.programmeFarmerName = data.FarmerName;
    this.programName = data.ProgrammeName;
    this.ProgramID = data.ProgramID;
    this.vendorCode = data.Vendor_Code;
    this.isSubmitted = false;
    this.surveyArea = data.Total_Area;
    this.applyConditionalValidation(data);
  }
  updateEstimation(data) {
    // this.getCurrentLocation();
    // this.addOverlay();
    // this.refreshLocation = setInterval(() =>
    //     this.onRefreshCurrentLocation(), 6000)
    this.geolocationsarray = [];
    this.surveyArea = data.Total_Area
    
    this.isSubmitted = false;
    this.applyConditionalValidation(data);
    this.displayPreEstDialog = true;
    this.programmeFarmerName = data.FarmerName;
    let reqBody = {
      AppId: data.appID,
      ProgramId: data.ProgramID,
    };
    // this.loader.start();
    this.loading = true;
    this.vendorService
      .GetEditPreEstimationSurvey(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (typeof data.WaterPressure == 'number') {
            data.WaterPressure = JSON.stringify(data.WaterPressure);
          }
          if (typeof data.WaterQuantity == 'number') {
            data.WaterQuantity = JSON.stringify(data.WaterQuantity);
          }
          // this.loader.close();
          this.loading = false;
          this.programmeAppId = data.AppID;
          this.programName = data.ProgramName;
          this.ProgramID = data.ProgId;
          this.vendorCode = data.VendorCode;
          this.f.soilType.setValue(data.SoilType);
          this.f.cropType.setValue(data.CropTypeID);
          this.f.cropId.setValue(data.CropId);
          this.f.waterSource.setValue(data.WaterSourceId);
          this.f.waterPressure.setValue(data.WaterPressure);
          this.f.waterQuality.setValue(data.WaterQuality);
          this.f.ph.setValue(data?.PH);
          this.f.ec.setValue(data?.EC);
          this.f.waterReq.setValue(data.WaterQuantity);
          this.f.plantSpacing.setValue(data.PlantSpacing);
          this.f.rowSpacing.setValue(data.RowSpacing);
          for (let index = 0; index < data.listGPSCoordinates.length; index++) {
            let geoData = {
              CornerID: data.listGPSCoordinates[index].CornerID,
              lat: data.listGPSCoordinates[index].Latitude,
              lng: data.listGPSCoordinates[index].Longitude,
            };
            this.geolocationsarray.push(geoData);
          }
          if (this.geolocationsarray.length == 0) {
            this.mapEnable = false;
          } else {
            if (this.geolocationsarray && this.geolocationsarray.length > 0) {
              this.options.center = this.geolocationsarray[0];
            }
            this.mapEnable = true;
            this.geolocationsarray.forEach((row, index) => {
              this.addMarkers(row, index);
            });
            this.addOverlay();
          }

          for (let index = 0; index < data.listImagePath.length; index++) {
            let imagesData = {
              attachment: data.listImagePath[index].ImagePath,
              attachmentRawUrl: data.listImagePath[index].ImagePath,
              document_type: data.listImagePath[index].DocumentType,
              displayName: data.listImagePath[index].DocumentType,
              name: data.listImagePath[index].DocumentType,
            };
            this.documentList.push(imagesData);
          }
        },
      });
  }

  applyConditionalValidation(data){
    if(data?.ApplicantType == '7500' && data?.ProgrammeName == 'Drip Irrigation'){
      this.submitEstimateForm.controls['rowSpacing'].setValidators([Validators.min(0.3)]);
      this.submitEstimateForm.controls['plantSpacing'].setValidators([Validators.min(0.6)]);
    }
    else{
      this.submitEstimateForm.controls['rowSpacing'].clearValidators();
      this.submitEstimateForm.controls['plantSpacing'].clearValidators();
      this.submitEstimateForm.controls['rowSpacing'].setValidators([Validators.required]);
      this.submitEstimateForm.controls['plantSpacing'].setValidators([Validators.required]);
    }
    this.submitEstimateForm.controls['rowSpacing'].updateValueAndValidity();
    this.submitEstimateForm.controls['plantSpacing'].updateValueAndValidity();
  }

  selectViewApplication(application, statusCode) {
    if (application.appID) {
      let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
          application.appID,
        ])
      );
      window.open(link, '_blank');
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Invalid App ID',
      });
    }
  }
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.appID,
          'date of Submit':d.registerationDate_filter,
          'date of Resubmit':d.registerationReassignDate_filter,
          'Applicant Type': d.ApplicantType,
          'App type': d.FarmerName,
          "Village": d.village,
          'block': d.block,
          'District': d.district,
          'Age Of Application': d.AgeOfApplication,
          'Program Name': d.ProgrammeName,
          'Land Detail': d.LandDetail,
          'Total Area': d.Total_Area,
          'current status': d.Status_Ar,
          'Remarks': d.DeptRemarks,
          'Act on PrevAction': d.ActOnPrevAction,
          
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'appID', header: 'appID' },
      { field: 'registerationDate_filter', header: 'date of Submit' },
      { field: 'registerationReassignDate_filter', header: 'date of Resubmit' },
      { field: 'ApplicantType', header: 'Applicant type' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'village', header: 'village' },
      { field: 'block', header: 'block' },
      { field: 'district', header: 'district' },
      { field: 'AgeOfApplication', header: 'Age Of Application' },
      { field: 'ProgrammeName', header: 'Program Name' },
      { field: 'LandDetail', header: 'Land Detail' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'Status_Ar', header: 'current status' },
      { field: 'DeptRemarks', header: 'Remarks' },
      { field: 'ActOnPrevAction', header: 'Act on PrevAction' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});

        doc.save(`${filename}.pdf`);
      });
    });
  }
  refreshTable() {
    // this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
    this.loadData();
  }
}
